/**
 * House of Places — step through the enlarged product images.
 *
 * Dawn renders every media into one scrolling column, so opening an image and
 * wanting the next one meant scrolling a full viewport. The CSS shows one at a
 * time; this moves the `.active` marker Dawn already uses, so the modal's own
 * open/close and focus handling stay untouched.
 */
(function () {
  // Dawn's quick-add modal re-runs every script inside <product-info> each
  // time it opens; bind once per page so no listener fires twice.
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-lightbox']) return;
  yuklu['hop-lightbox'] = true;

  function ogeler(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll('.product-media-modal__content > *'),
    ).filter(function (el) {
      return el.offsetParent !== null || el.classList.contains('active');
    });
  }

  function kaydir(modal, yon) {
    var hepsi = Array.prototype.slice.call(
      modal.querySelectorAll('.product-media-modal__content > *'),
    );
    if (hepsi.length < 2) return;
    var simdi = hepsi.findIndex(function (el) {
      return el.classList.contains('active');
    });
    if (simdi < 0) simdi = 0;
    var sonraki = (simdi + yon + hepsi.length) % hepsi.length;
    hepsi[simdi].classList.remove('active');
    hepsi[sonraki].classList.add('active');
    // Pause anything that was playing before it scrolls out of view.
    var video = hepsi[simdi].querySelector('video');
    if (video && typeof video.pause === 'function') video.pause();
  }

  // Dawn closes a media-modal on ANY mouse pointerup whose target is not inside
  // deferred-media or product-model (global.js:610). The arrows are neither, so
  // every click on one stepped the image AND shut the modal — the shopper saw
  // it slam closed the moment they tried to browse.
  //
  // Bound on the arrows themselves rather than added to Dawn's exception list:
  // the listener runs at the target phase, before the event reaches the modal,
  // and global.js stays untouched for the next theme update.
  function susturan(e) {
    if (e.target.closest('.hop-lb-arrow')) e.stopPropagation();
  }
  document.querySelectorAll('.hop-lb-arrow').forEach(function (ok) {
    ok.addEventListener('pointerup', susturan);
    ok.addEventListener('pointerdown', susturan);
  });

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-hop-lb-prev]');
    var next = e.target.closest('[data-hop-lb-next]');
    if (!prev && !next) return;
    var modal = e.target.closest('.product-media-modal');
    if (!modal) return;
    e.preventDefault();
    kaydir(modal, prev ? -1 : 1);
  });

  // Arrow keys read naturally once the modal is the thing on screen.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var modal = document.querySelector('.product-media-modal[open]');
    if (!modal) return;
    kaydir(modal, e.key === 'ArrowLeft' ? -1 : 1);
  });
})();
